/*
 *
 * OktaAuthCallback constants
 *
 */

export const SET_OKTA_TOKEN_ACTION =
  'app/OktaAuthCallback/SET_OKTA_TOKEN_ACTION';
export const SET_ERROR_ACTION = 'app/OktaAuthCallback/SET_ERROR_ACTION';
export const RESET_TO_DEFAULT_ACTION =
  'app/OktaAuthCallback/RESET_TO_DEFAULT_ACTION';
